import React, { FC } from 'react';
import styled from 'styled-components';
import { fontSize } from 'styles/theme';
import { VideoPlayer } from 'components/video/VideoPlayer';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { SubSectionHeadline } from 'src/pages-all/home/components/parts/default.parts';
import { AppRoute } from 'app/app.route.const';
import { Text } from 'components/text/Text';
import { highlightedBodyFontSize } from 'src/pages-all/home/home.page.const';
import { useDispatch } from 'react-redux';
import { navigationSlice } from 'logic/store/navigation/navigation.slice';
import { Button } from 'antd';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  margin-bottom: 60px;
  text-align: center;
`;

const InfoWrapper = styled.div`
  margin-bottom: 20px;
`;

const VideoWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
`;

const InfoTextWrapper = styled.div``;

const InfoText = styled.p`
  font-size: ${fontSize.base};
`;

type Props = {
  videoID: string;
  text: {
    headline?: string;
    subheadline?: string;
    infoText?: string;
    buttonText?: string;
  };
  buttonURL?: string;
};

export const InfoVideoBox: FC<Props> = ({ videoID, text, buttonURL }) => {
  const dispatch = useDispatch();
  const _buttonUrl = buttonURL || AppRoute.Home;
  const { maxMobileLarge } = useBreakpoints();
  return (
    <Wrapper style={{ padding: maxMobileLarge ? 0 : '' }}>
      <InfoWrapper>
        <SubSectionHeadline headline={text?.headline} center />
      </InfoWrapper>
      <InfoTextWrapper style={{ margin: '0 0 40px 0' }}>
        {text?.subheadline &&
          text?.subheadline.split('\n').map((line, index) => (
            <div key={index}>
              <Text
                fontWeight={600}
                color={'blueGray'}
                size={highlightedBodyFontSize(maxMobileLarge)}
              >
                {line}
              </Text>
            </div>
          ))}
      </InfoTextWrapper>
      <VideoWrapper>{videoID && <VideoPlayer id={videoID} ratio={0.5} />}</VideoWrapper>
      <InfoTextWrapper>
        {text?.infoText &&
          text?.infoText.split('\n').map((line, index) => <InfoText key={index}>{line}</InfoText>)}
      </InfoTextWrapper>
      {text?.buttonText && (
        <Button
          type={'primary'}
          style={{ margin: '24px', fontWeight: 600, height: 'auto' }}
          onClick={() => {
            dispatch(navigationSlice.actions.navigateTo({ path: _buttonUrl }));
          }}
        >
          <Text color={'white'}>{text?.buttonText}</Text>
        </Button>
      )}
    </Wrapper>
  );
};
